// src/components/GenericPdfDownloader.jsx
import React from 'react';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';

const GenericPdfDownloader = ({ document, fileName, isViewer = false }) => {

    if (isViewer) {
        return (
            <PDFViewer style={{ width: '100%', height: '80vh', border: 'none' }}>
                {document}
            </PDFViewer>
        );
    }

    return (
        <PDFDownloadLink document={document} fileName={fileName}>
            {({ blob, url, loading, error }) =>
                loading ? 'Preparando documento...' : 'Descargar PDF'
            }
        </PDFDownloadLink>
    );
};

export default GenericPdfDownloader;